import { render, staticRenderFns } from "./PbDashboardPeriodBadge.vue?vue&type=template&id=4960c3cc&"
import script from "./PbDashboardPeriodBadge.vue?vue&type=script&lang=js&"
export * from "./PbDashboardPeriodBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports